<template>
  <div class="scene">
    <canvas class="pano"  ref="pano"></canvas>
  </div>
</template>

<style scoped>

  .scene {
    position: absolute;
    margin: 0;
    background-color: #000;
    color: #fff;
    overscroll-behavior: none;
    z-index: -2;

    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .pano {
    display:block;
  }
</style>

<script>
// @ is an alias to /src

import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
// import { DeviceOrientationControls } from "three/examples/jsm/controls/DeviceOrientationControls";
import { PanoDeviceControls } from "@/util/PanoDeviceControls.js";
import { Howl } from 'howler';
import {gsap} from 'gsap'
//import glitter from "@/assets/images/textures/particle.png"

// const VideoStamps = {
//   enter : [0, 25],
//   painting  : [25, 25.8],
//   zoom  : [25.8, 26.9],
//   end : [26.9, 9999]
// }

const VideoStamps = {
  enter : [0, 17.5],
  painting  : [17.5, 19.4],
  paintingOut : [19.4, 20.71],
  zoom  : [20.71, 21.9],
  end : [21.9, 9999]
}

const Zoom = {
 IN : 38,
 OUT : 75,
}

const PAINTING_DELAY = 3;
const MENU_DELAY = 1;

export default {
  name: "Room",
  components: {
  },

  props : {
    artistID : String,
    loadImmediate : String
  },

  data() {
    return {
      renderer : null,
      scene : null,
      camera:  null,
      controls : null,
      deviceControls : null,
      skybox : null,
      onUpdate : null,
      parameters : null,
      allowInput : false,
      materials : [],
      animationFrameID : null,
      timeline : new gsap.timeline(),
      environment : {},
      menuDelay : MENU_DELAY,
      paintingDelay: PAINTING_DELAY,
      bgm: null,
      menuState : 'enter',
      meshes : [],
      videos : [],
      videoTexture: null,
      isUserInteracting : false,
      onMouseDownMouseX : 0, 
      onMouseDownMouseY : 0,
      lon : 0, onMouseDownLon : 0,
      lat : 0, onMouseDownLat : 0,
      phi : 0, 
      theta : 0,
      delay : 0,
    }
  },

  computed : {
    screen : function () { return this.$store.state.screens.room },
    galleryPano : function () { return this.isMobile ? this.screen.gallery.mobile : this.screen.gallery.pano},
    artistPano : function () { return this.isMobile ? this.artist.mobile : this.artist.pano},
    aspect : function () { return window.innerWidth / window.innerHeight },
    artist : function () { return this.$store.state.artists.find( a =>  a.key == (this.$props.artistID || this.screen.artist) )},
    state : function () { return this.screen.state },
    back : function() { return this.$store.state.back },
    isMobile : function() { return this.$store.state.environment.isMobile },
    accelerometerRequest : function() { return this.$store.state.accelerometerRequest; },
    enterRoom : function() { return this.$store.state.enterRoom},
    galleryVideo :  function() { return this.$store.state.resources[this.galleryPano].data;},
    zoomIn : function(){ return this.$store.state.zoomIn},
    zoomOut : function(){ return this.$store.state.zoomOut},
    endTransition : function(){ return this.$store.state.endTransition},
    transition : function(){ return this.$store.state.transition}
  },

  watch : {
    state(newState) {
      console.log('NEW STATE');
      if(newState == 'load') {
        this.loadScene();
      }

      if(newState == 'unload') {
        this.unloadScene();
      }

      if(newState == 'gallery') {
        this.setGallery();
      }
    },

    back(){
      this.onBack();
    },

    zoomIn(){
      this.timeline.clear();
      this.timeline.to(this.camera, 0.5, {fov : Zoom.IN, onUpdate : ()=> this.camera.updateProjectionMatrix()});
    },

    zoomOut(){
      this.timeline.clear();
      this.timeline.to(this.camera, 0.5, {fov : Zoom.OUT, onUpdate : ()=> this.camera.updateProjectionMatrix()});
    },


    menuState(newState, oldState){
      if(newState == 'zoom'){
        this.galleryVideo.currentTime = VideoStamps.zoom[0];
        this.galleryVideo.pause();
        
        console.log('oldState', oldState);
        console.log('screenState', this.state);

        gsap.delayedCall(this.menuDelay, () => {
          this.$store.commit('enterGallery');
          this.$store.commit('show','menu')
        })

        //this.timeline.clear();
        //this.timeline.to({v : 0}, this.menuDelay, {v : this.menuDelay, onComplete:  () =>  });
      }

      if(newState == 'paintingOut'){
        if(this.paintingDelay > 0) {
          //this.galleryVideo.currentTime = VideoStamps.paintingOut[1];
          this.galleryVideo.pause();

          gsap.delayedCall(this.paintingDelay, () => {
            this.paintingDelay = 0;
            this.galleryVideo.play();
          })
        } else {
          this.$store.commit('setTransition', 'in');
        }
        
      }

      if(newState == 'end'){
        this.$store.commit('setTransition', 'out')
      }

      if(newState == 'enter'){
        this.$store.commit('setTransition', 'in');
      }
    },

    accelerometerRequest(){
      this.enableDeviceControls();
    },

    enterRoom(){
      if(this.state == 'gallery'){
        let video = this.galleryVideo;
        video.currentTime = VideoStamps.zoom[0];
        video.play();
      }
    },

    endTransition(){
      if(this.state != 'load' && this.state != 'gallery') return;
      if(this.transition == 'out'){
        if(this.state == 'gallery' && this.menuState == 'end') {
          this.$nextTick(() => {
             this.unloadGallery();
             this.menuDelay = 0;
             this.$store.commit('startRoom');
             this.$store.commit('setState', {name : 'room', state : 'load'});
             this.$store.commit('setTransition', 'in')
          })
        } else if(this.state == 'gallery' && this.menuState == 'zoom') {
             this.$nextTick(() => {
                this.galleryVideo.currentTime = 0;
                this.menuDelay = MENU_DELAY;
                this.paintingDelay = PAINTING_DELAY;
                this.unloadGallery();
                this.$store.commit('setState', {name : 'room', state : 'default'});
                this.$store.commit('hide', 'menu');
                this.$store.commit('show', 'splash');
                this.$store.commit('setTransition', 'in');
             })
        } else if(this.state == 'load') {
          this.unloadScene();
          this.$store.commit('setState', {name : 'room', state : 'gallery'});  
          
          // this.$nextTick(() => {
            
          // })
        }
        
      } 
    }
  },

  methods : {
    load : function () {
        console.log(THREE, OrbitControls);
        let renderer = new THREE.WebGLRenderer({
          canvas : this.$refs.pano
        });

        
      
        console.log('init', this.$props.loadImmediate);

        renderer.setPixelRatio( window.devicePixelRatio);
        renderer.setSize(window.innerWidth, window.innerHeight);

        this.renderer = renderer;
        
        this.camera = new THREE.PerspectiveCamera( 75, this.aspect, 1, 1100);
        this.scene = new THREE.Scene();

        this.onUpdate = () => this.update();
        
        this.controls = new OrbitControls(this.camera, renderer.domElement);
        this.controls.addEventListener('change', ()=> this.update());
        this.controls.minDistance = 3;
        this.controls.maxDistance = 500;
        this.controls.panSpeed = 0.5;
        this.controls.rotateSpeed = 0.25;
        this.controls.target.set(0, 0, - 0.2);
        this.controls.update();

        

        window.addEventListener('resize', () => this.onResize(), false);
        this.$refs.pano.addEventListener('touchstart', (e) => this.onPointerStart(e), false);
        this.$refs.pano.addEventListener('touchmove', (e) => this.onPointerMove(e), false);
        this.$refs.pano.addEventListener('touchend', (e) => this.onPointerEnd(e), false);
        

        
       
        console.log(this.artist);
        //if(this.$props.loadImmediate) this.loadScene();
    },

    

    enableDeviceControls() {
      if(!this.deviceControls) {
        this.deviceControls = new PanoDeviceControls(this.camera);
        this.deviceControls.enabled = false;
        this.camera.lookAt(-300,0,0);
      }
    },

    setGallery(){
      //this.addLayer(this.screen.gallery.pano);
      let video = this.galleryVideo;

      if(this.menuState == 'end') {
        video.currentTime = VideoStamps.paintingOut[0]; // Sets the video right before painting state
        //video.play();
      }

      if(this.deviceControls) {
        this.deviceControls.enabled = false;
      }
      
      this.loadScene(this.galleryPano, false, null, false);
      this.camera.lookAt(-300,0,0);
      this.camera.fov = Zoom.OUT;
      this.camera.updateProjectionMatrix();
      this.controls.enabled = false;

      

      video.addEventListener('timeupdate', this._onVideoProgress);
      video.loop = false;
    },

    unloadGallery(){
      let video = this.galleryVideo;
      video.removeEventListener('timeupdate', this._onVideoProgress);
      this.unloadScene()
      this.camera.lookAt(0,0,0);
      this.controls.enabled = true;
    },

    loadScene : function(scene, bgm, particles, allowInput = true) {
      console.log('UNLOADING SCENE');
      if(!scene) scene = this.artistPano;
      if(!particles) particles = this.artist.particles;
      if(bgm == null) bgm = this.artist.bgm;

        if(Array.isArray(scene)){
          scene.forEach(p => typeof p == 'string' ? this.addLayer(p) : this.addLayer(p.src));
        } else {
          this.addLayer(scene);
        }

        if(particles) this.loadParticles();
        this.animationFrameID = window.requestAnimationFrame(() => this.animate());
        if(bgm){
          this.bgm = new Howl({
            src : [require(`@/assets/audio/${bgm}`)],
            autoplay : true,
            loop : true,
            volume : this.artist.volume || 0.5
          })
        }

         if(allowInput){
           this.allowInput = true;
           //if(this.environment.isMobile) window.addEventListener('deviceorientation', (e)=> this.enableDeviceControls(e), true);
           if(this.deviceControls) this.deviceControls.enabled = true;
           if(this.controls) this.controls.enabled = true;
         } else {
           this.allowInput = false;
         } 

    },

    _onVideoProgress(evt) {
      //console.log('timeupdate');
      if(this.state == 'gallery') {
        console.log(evt.target.currentTime);
        let time = evt.target.currentTime;
        let stamp = VideoStamps[this.menuState];
        if(time < stamp[0] || time > stamp[1]) { 
          //evt.target.pause();
          for(let k in VideoStamps) {
            let newStamp = VideoStamps[k];
            console.log(newStamp[0], newStamp[1], time);
            if((time > newStamp[0] &&  time < newStamp[1]) || time == newStamp[0] || time == newStamp[1]){
              this.menuState = k;
              console.log('new state', k);
              break;
            }
          }

          console.log('menuState', this.menuState);
        }
      }
    },

    addLayer(imageSrc){
        var geometry = new THREE.SphereBufferGeometry( 500 + this.meshes.length, 60, 40);

        geometry.scale( -1, 1 ,1);
  
        var texture;
        var resource = this.$store.state.resources[imageSrc];
        if(imageSrc.match('.mp4')){
          let video = resource.data;//document.createElement('video');

         
          //video.src = require(`@/assets/images/textures/${imageSrc}`);
          
          
          document.body.appendChild(video);
          video.play();

          if(!this.videoTexture) {
            this.videoTexture = new THREE.VideoTexture(video);
          } else {
            this.videoTexture.image = video;
            this.videoTexture.needsUpdate = true;
          }

          //texture = new THREE.VideoTexture(video);
          texture = this.videoTexture;
          this.videos.push(video);
        } else {
          // texture = new THREE.TextureLoader().load(resource.data.src, () => this.update());
          texture = new THREE.Texture(resource.data);
          texture.needsUpdate = true;
        }

        var material = new THREE.MeshBasicMaterial( { map : texture, alphaTest : 0.8 });

        var pano = new THREE.Mesh(geometry, material);
        pano.name = imageSrc;
        this.scene.add( pano );

        this.meshes.push(pano);
    },

    unloadScene : function() {
      console.log('UNLOADING SCENE');

      //this.scene.remove(this.skybox);
      this.scene.children.concat().forEach(c => this.scene.remove(c));
      this.meshes.length = 0;
      this.videos.forEach(v => {
        document.body.removeChild(v);
      })

      this.videos.length = 0;
      //this.renderer = null;
      this.skybox = null;
      //this.controls.removeEventListener('change', this.onUpdate);
      this.renderer.render( this.scene, this.camera);
      window.cancelAnimationFrame(this.animationFrameID);
      if(this.bgm){
        this.bgm.stop();
        this.bgm = null;
      }
      //this.onUpdate = null;
    },

    loadParticles() {
      let geometry = new THREE.BufferGeometry();
      let vertices = [];
      let textureLoader = new THREE.TextureLoader();

      let sprite = textureLoader.load(require("@/assets/images/textures/particle.png"));

      for (let i = 0; i < 120; i++) {
        let x = Math.random() * 2000 - 1000;
        let y = Math.random() * 2000 - 1000;
        let z = Math.random() * 2000 - 1000;

        vertices.push(x, y, z);
      }

      geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));

      this.parameters = [
        [[ 1.0, 0.2, 0.5 ], sprite, 20 ],
				[[ 0.95, 0.1, 0.5 ], sprite, 15 ],
				[[ 0.90, 0.05, 0.5 ], sprite, 10 ],
				[[ 0.85, 0, 0.5 ], sprite, 8 ],
				[[ 0.80, 0, 0.5 ], sprite, 5 ]
      ];

      this.parameters.forEach( (p,i) => {
        let color = p[0];
        let sprite = p[1];
        let size = p[2];

        this.materials[i] = new THREE.PointsMaterial( {size : size, map : sprite, blending : THREE.AdditiveBlending, depthTest : false, transparent : true});
        this.materials[i].color.setHSL( color[0], color[1], color[2]);

        var particles = new THREE.Points(geometry, this.materials[i]);

        particles.rotation.x = Math.random() * 6;
        particles.rotation.y = Math.random() * 6;
        particles.rotation.z = Math.random() * 6;

        this.scene.add( particles );
      })
 
    },

    animate() {
        this.animationFrameID = window.requestAnimationFrame(() => this.animate());
        this.update();
    },

    update : function() {
        if(!this.screen.active) return;
        if(!this.renderer) return;
        this.updateParticles();
        this.updateControls();
        this.updateBehaviors();
        this.renderer.render( this.scene, this.camera);
    },

    updateControls(){
      this.lat = Math.max( - 85, Math.min( 85, this.lat ) );
      this.phi = THREE.MathUtils.degToRad( 90 - this.lat );
      this.theta = THREE.MathUtils.degToRad( this.lon );

      if (this.deviceControls) this.deviceControls.update(this.lon, this.lat);
    },

    updateParticles() {
      var time = Date.now() * 0.00002;

      this.scene.children.forEach((c,i) => {
        if(c instanceof THREE.Points) {
          c.rotation.y = time * (i < 4 ? i + 1 : - (i + 1))
        }
      })
    },

    updateBehaviors() {
      if(Array.isArray(this.artist.pano)){
        this.artist.pano.forEach(p => {
          if(typeof p == 'object'){
            this.executeBehavior(p);
          }
        })
      }
    },

    executeBehavior( element ){
      let mesh = this.meshes.find(m => m.name == element.src);
      if(!mesh) return;
      switch(element.behavior) {
        case 'rotate':
          mesh.rotation.y += this.toRadians(element.speed);
          break;
      }
    },

    onBack() {
      if(!this.screen.active) return;

      if(this.state == 'load') {
        this.$store.commit('setTransition', 'out');
      }

      if(this.state == 'gallery' && this.menuState=='zoom'){
        this.$store.commit('setTransition', 'out');
      }
      
    },

    onTouch(){
      console.log('ON TOUCH');
      if(this.deviceControls){
        //this.deviceControls.enabled = false;
        //this.controls.dispose();
        //this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      }
    },

    onRelease(){
      if(this.deviceControls){
        //this.deviceControls.enabled = true;
      }
    },

    

    onResize(){
      if(this.camera && this.renderer){
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
      }
    },

    onPointerStart( event ) {

      this.isUserInteracting = true;

      var clientX = event.clientX || event.touches[ 0 ].clientX;
      var clientY = event.clientY || event.touches[ 0 ].clientY;

      this.onMouseDownMouseX = clientX;
      this.onMouseDownMouseY = clientY;

      this.onMouseDownLon = this.lon;
      this.onMouseDownLat = this.lat;

    },

    onPointerMove( event ) {

      if ( this.isUserInteracting === true ) {

        var clientX = event.clientX || event.touches[ 0 ].clientX;
        var clientY = event.clientY || event.touches[ 0 ].clientY;

        this.lon = ( this.onMouseDownMouseX - clientX ) * 0.1 + this.onMouseDownLon;
        this.lat = ( clientY - this.onMouseDownMouseY ) * 0.1 + this.onMouseDownLat;

      }

    },

    onPointerUp() {

      this.isUserInteracting = false;

    },

    toRadians(deg){
      return deg * Math.PI / 180;
    }

    
  },

  mounted: function(){


    this.load();
  }
};
</script>
